module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "template-show"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v(_vm._s(_vm.$t('template.label.preShow')) + ":"), _c('span', {
    staticClass: "name"
  }, [_vm._v(" " + _vm._s(_vm.template.name))]), _vm._m(0)]), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.template.kind == 'email') ? [_c('div', {
    staticClass: "subject-legend"
  }, [_vm._v(_vm._s(_vm.$t('template.attributes.subject')) + ":")]), _c('div', {
    staticClass: "subject"
  }, [_vm._v(_vm._s(_vm.template.subject))])] : _vm._e(), _c('div', {
    staticClass: "body-legend"
  }, [_vm._v(_vm._s(_vm.template.contentLabel()) + ":")]), _c('div', {
    staticClass: "body email-body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.template.body)
    }
  }), (_vm.template.kind == 'email') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.template.signature || _vm.current_user.signature)
    }
  }) : _vm._e()])], 2), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn btn-gray",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.close')))]), (_vm.current_user.can_manage_templates) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal",
      "to": _vm.editPath
    }
  }, [_vm._v(_vm._s(_vm.$t('template.actions.edit')))]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-760c0ee6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/show_modal.vue
// module id = 1168
// module chunks = 1